(function () {
	'use strict';

	a3_cabin_reports.controller('MemosCtrl', MemosCtrl);

	/**
	* @memberof CabinReports
	* @ngdoc controller
	* @name MemosCtrl
	* @description 
	*  Manages the Memos View
	* @ngInject
	*/

	function MemosCtrl($scope, MemoFactory, $uibModal, $routeParams) {

		$scope.memosByCategory = [];
		$scope.openMemo = openMemo;
		$scope.searchText = '';
		$scope.searchMemos = searchMemos;
		$scope.state = 'memos';
		$scope.select = select;
		$scope.toggleSidePanel = toggleSidePanel;
		$scope.searchResultsCount = searchResultsCount;
		$scope.shownSideMenu = false;
		$scope.active = 1;
		$scope.showhideDescr = showhideDescr;
		$scope.toShowBody = true;
		$scope.toShowAppliesTo = true;

		$scope.hasCountry = false;
		$scope.hasFlightNo = false;
		$scope.hasAirport = false;
		$scope.hasRoute = false;
		$scope.hasAcType = false;
		$scope.hasZone = false;
		$scope.hasEuropean = false;
		$scope.hasSchengen = false;
		$scope.hasAcRegistration = false;
		$scope.hasSsrCode = false;
		$scope.hasTrainingIndicator = false;
		$scope.hasGroundDuties = false;
		$scope.hasNone = true;

		MemoFactory.getNotHiddenMemos(function (results) {

			var tommorowTimestamp = new Date().getTime() + 86400000;
			for (var i = 0; i < results.length; i++) {
				results[i].expired = new Date(results[i].ValidTo).getTime() < tommorowTimestamp;
			}

			$scope.memos = results;

			var memosByCategory = MemosByCategories(results);

			if ($routeParams.filter == 'unread') {
				$scope.radioModel = 'Unread';
				searchMemos($scope.searchText, 'Unread');
			}
			else if ($routeParams.filter == 'unreadMandatory') {
				$scope.radioModel = 'UnreadMandatory';
				searchMemos($scope.searchText, 'UnreadMandatory');
			}
			else {
				$scope.radioModel = 'All';
				//default category on load
				$scope.selected = memosByCategory[0];
				$scope.memosByCategory = memosByCategory;
				searchResultsCount();
			}
		});

		function searchResultsCount() {
			var sum = 0;
			for (var i = 0; i < $scope.memosByCategory.length; i++) {
				sum += $scope.memosByCategory[i].memoList.length;
			}
			$scope.searchResults = sum;
		}

		function MemosByCategories(memoList) {
			var memos = [];
			for (var i = 0; i < memoList.length; i++) {
				var memo = memoList[i];
				if (!memos.filter(function (e) { return e.Category == memo.Category }).length > 0) {
					memos.push(
						{
							Category: memo.Category,
							memoList: [memo],
							filterList: [memo]
						});
				}
				else if (memos.filter(function (e) { return e.Category == memo.Category }).length > 0) {

					memos.filter(function (object) {
						if (object.Category == memo.Category) {
							return object;
						};
					})[0].memoList.push(memo);
					memos.filter(function (object) {
						if (object.Category == memo.Category) {
							return object;
						};
					})[0].memoList.dynamicSort("LastUpdated", false);
				}

				(function changeFlags() {
					angular.forEach(memoList[i].MemoCriteria, function (criteria) {
						if (criteria.Country || criteria.Type == "Country" && criteria.Field) {
							$scope.hasCountry = true;
							$scope.hasNone = false;
						}
						if (criteria.FlightNo || criteria.Type == "FlightNo" && criteria.Field) {
							$scope.hasFlightNo = true;
							$scope.hasNone = false;
						}
						if (criteria.Airport || criteria.Type == "Airport" && criteria.Field) {
							$scope.hasAirport = true;
							$scope.hasNone = false;
						}
						if (criteria.RouteStart || criteria.Type == "RouteStart" && criteria.Field) {
							$scope.hasRoute = true;
							$scope.hasNone = false;
						}
						if (criteria.AcType || criteria.Type == "AcType" && criteria.Field) {
							$scope.hasAcType = true;
							$scope.hasNone = false;
						}
						if (criteria.Zone || criteria.Type == "Zone" && criteria.Field) {
							$scope.hasZone = true;
							$scope.hasNone = false;
						}
						if (criteria.AcRegistration || criteria.Type == "AcRegistration" && criteria.Field) {
							$scope.hasAcRegistration = true;
							$scope.hasNone = false;
						}
						if (criteria.Type == "SsrCode" && criteria.Field) {
							$scope.hasSsrCode = true;
							$scope.hasNone = false;
						}
						if (criteria.Type == "TrainingId" && criteria.Field) {
							$scope.hasTrainingIndicator = true;
							$scope.hasNone = false;
						}
						if (criteria.Type == "European" && criteria.Field) {
							$scope.hasEuropean = true;
							$scope.hasNone = false;
						}
						if (criteria.Type == "Schengen" && criteria.Field) {
							$scope.hasSchengen = true;
							$scope.hasNone = false;
						}
						if (criteria.Type == "GroundDutyCode" && criteria.Field) {
							$scope.hasGroundDuties = true;
							$scope.hasNone = false;
						}
					})
				})();
			}
			return memos.dynamicSort("Category", true);
		}

		function select(category) {
			selectMemoCategory(category);
			toggleSidePanel();
		}

		function selectMemoCategory(category) {
			var memosByCategory = $scope.memosByCategory;
			for (var i = 0; i < memosByCategory.length; i++) {
				if (memosByCategory[i].Category == category.Category) {
					$scope.selected = memosByCategory[i];
					break;
				}
			}
		}

		function showhideDescr() {
			$scope.toShowBody = !$scope.toShowBody
			$scope.toShowAppliesTo = !$scope.toShowAppliesTo
		}

		function toggleSidePanel() {
			$scope.shownSideMenu = !$scope.shownSideMenu;
		}

		//Pagination
		$scope.pageOptions = [
			{ name: '5', value: '5' },
			{ name: '8', value: '8' },
			{ name: '15', value: '15' },
			{ name: '30', value: '30' },
			{ name: '50', value: '50' }
		];

		$scope.viewby = $scope.pageOptions[1].value;
		$scope.currentPage = 1;
		$scope.itemsPerPage = $scope.viewby;
		$scope.maxSize = 5; //Number of pager buttons to show
		$scope.setPage = setPage;
		$scope.setItemsPerPage = setItemsPerPage;

		//Controller functions

		/**
		* Set pagination page number
		* @memberof MemosCtrl
		* @param {number} pageNo list page number
		*/
		function setPage(pageNo) {
			$scope.currentPage = pageNo;
		}

		/**
		 * Set items per  page 
		 * @memberof MemosCtrl
		 * @param {number} num the Number of items to show per page
		 */
		function setItemsPerPage(num) {
			$scope.itemsPerPage = num;
			$scope.currentPage = 1; //reset to first paghe
		}

		/**
		 * View Selected Memo
		 * @memberof MemosCtrl
		 * @param {object} memo The selected Memo
		 */
		function openMemo(memo) {
			var modalInstance = $uibModal.open({
				templateUrl: 'views/Dialogs/dlgMemo.html',
				controller: 'MemoModalCtrl',
				size: 'lg',
				keyboard: false,
				resolve: {
					memo: function () {
						return memo;
					}
				}
			});

			modalInstance.result.then(function () {
				if (memo.ReadDt == null) {
					memo.ReadDt = new Date();
					MemoFactory.saveOneMemoToStorage(memo);

					//check if memo is connected to a ground duty
					for (var i = 0; i < memo.MemoCriteria.length; i++) {
						var item = memo.MemoCriteria[i];
						if (item.QueryType == "GroundDutyCode") {
							MemoFactory.markGroundDutiesUnread();
							break;
						}
					}
					searchMemos($scope.searchText, '');
				}
			})
		}

		function redirectModal() {
			var modalInstance = $uibModal.open({
				templateUrl: 'views/Dialogs/dlgCalendarRedirect.html',
				controller: 'CalendarRedirectModalCtrl',
				backdrop: 'static',
				size: 'md',
				keyboard: false
			});
		}

		/**
		 * Search the selected text In Memo Title and body
		 * @memberof MemosCtrl
		 * @param {string} text The desired search text
		 */
		function searchMemos(text, filter) {
			if (filter != '') {
				$scope.radioModel = filter;
			}
			var filteredMemos = [];
			var searchText = text.toLowerCase();
			var newList = $scope.memos;

			for (var i = 0; i < newList.length; i++) {
				if ($scope.radioModel == 'General') {
					if (newList[i].MemoCriteria && newList[i].MemoCriteria.length > 0) {
						continue;
					}
				}
				else if ($scope.radioModel == 'Unread') {
					if (newList[i].ReadDt) {
						continue;
					}
				}
				else if ($scope.radioModel == 'Mandatory') {
					if (!newList[i].IsMandatory) {
						continue;
					}
				}
				else if ($scope.radioModel == 'UnreadMandatory') {
					if (newList[i].ReadDt || !newList[i].IsMandatory) {
						continue;
					}
				}
				else if ($scope.radioModel == 'Monthly') {

					var diffTime = Math.abs(new Date() - moment.utc(newList[i].LastUpdated).utc().toDate());
					var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

					if (diffDays >= 30) {
						continue;
					}
				}

				var memoTitle = newList[i].Title.toLowerCase();

				if (memoTitle.indexOf(searchText) > -1) {
					filteredMemos.push(newList[i]);
					continue;
				}
			}

			var memosByCategory = MemosByCategories(filteredMemos);
			$scope.memosByCategory = memosByCategory;

			var showAllCategory = {
				Category: 'Show All',
				memoList: filteredMemos,
				filterList: filteredMemos
			}

			if (searchText != null && searchText != undefined && searchText.length > 0) {
				memosByCategory.push(showAllCategory);
			}

			searchResultsCount();

			if (!memosByCategory || !memosByCategory.length) {
				$scope.selected == null		//selected could be null if search didn't return any results
				if ($scope.radioModel == 'UnreadMandatory') {	//all mandatory memos were read
					// $scope.radioModel = 'All';
					// searchMemos(searchText, '');
					redirectModal();
				}
			}
			else if ($scope.selected == null) { //search now returns results
				$scope.selected = memosByCategory[0];
			}
			if (searchText != null && searchText != undefined && searchText.length > 0) {
				$scope.selected = showAllCategory;
			}

			var select = false;

			for (var i = 0; i < memosByCategory.length; i++) {
				if ($scope.selected.Category == memosByCategory[i].Category) {
					selectMemoCategory(memosByCategory[i]);
					select = true;
					break;
				}
			}
			if (!select) $scope.selected = memosByCategory[0];
		}
	}
})();